export const fakeAsyncFunction = (payload, fail = false) => {
	return new Promise((resolve, reject) => {
		setTimeout(() => {
			fail ? reject(new Error('Something went wrong. Please try again later.')) : resolve(payload);
		}, Math.random() * 1000);
	});
};
